import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import InputNumber from '../../../components/inputs/InputNumber';
import { importPreviewLinesLimit } from '../../store/import.state';

const ImporterPreviewLinesInput: React.FC = () => {
  const { t } = useTranslation('app');
  const [linesLimit, setLinesLimit] = useRecoilState(importPreviewLinesLimit);

  return (
    <InputNumber
      title={t`Preview Lines Limit:`}
      value={linesLimit}
      range={[1, Number.MAX_SAFE_INTEGER]}
      onChange={setLinesLimit}
      labelVertical
    />
  );
};

export default ImporterPreviewLinesInput;
